import { useSEO } from "@/lib/seo";
import PageHeader from "@/components/sections/PageHeader";
import Techniques from "@/components/sections/Techniques";
import FinalCTA from "@/components/sections/FinalCTA";

export default function TechniquesPage() {
  useSEO({
    title: "Radiation Therapy Techniques · IMRT, VMAT, IGRT, SRS, SBRT",
    description:
      "Advanced radiation therapy techniques including IMRT, VMAT, IGRT, SRS, SBRT, CyberKnife, Tomotherapy, Electron Beam Therapy, TBI and TSET.",
    keywords:
      "IMRT VMAT IGRT Radiation Therapy Hyderabad, CyberKnife Tomotherapy, SRS SBRT Radiation Oncologist",
    path: "/techniques",
  });

  return (
    <div data-testid="techniques-page">
      <PageHeader
        eyebrow="Radiation Therapy Techniques"
        title="Advanced techniques, chosen for the case."
        description="Dr. Anusha is skilled in the execution of precise radiation therapy techniques, applying the right platform for tumour type, location and clinical need."
      />
      <Techniques />
      <FinalCTA />
    </div>
  );
}
